<template>
    <PopupRouterViewDetail label="Picking For Delivery Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Picking Delivery" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Picking No" :model="model.pickingNumber" />
						<app-input-combobox-autocomplete :isEditable="isEditable" :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction" size="sm" :model.sync="model.deliveryInstructionId" :isRequired="false" :state="validateState('deliveryInstructionId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionId, 'deliveryInstructionId')"   :selected="model.deliveryInstruction != null ? model.deliveryInstruction.diNumber : ''" @input="getDeliveryInstructions" @change="updateData"  :isUpdatable="isEditable"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstruction" />
						<app-input-datepicker :isEditable="isEditable" id="fieldset-picking-date" label-cols-lg="12"  label="Picking Date" size="sm" :model.sync="model.pickingDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="isEditable" />
						<app-input-datetimepicker :isEditable="isEditable" id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="model.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="isEditable" />
						<app-input-datetimepicker :isEditable="isEditable" id="fieldset-finish-date" label-cols-lg="12"  label="Finish Date" size="sm" :model.sync="model.finishDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="isEditable" />
						<app-input-combobox-autocomplete :isEditable="isEditable" :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Picking By" id="fieldset-picking-by" size="sm" :model.sync="model.pickingByUserName"   :selected="model.pickingBy != null ? model.pickingBy.firstName : ''" @input="getUserInfos" @change="updateData"  :isUpdatable="isEditable"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPickingBy" />
						<app-input-combobox-autocomplete :isEditable="isEditable" :options="pickingStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Picking Status" id="fieldset-picking-status" size="sm" :model.sync="model.pickingStatusId"   :selected="model.pickingStatus != null ? model.pickingStatus.name : ''" @input="getPickingStatuss" @change="updateData"  :isUpdatable="isEditable"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPickingStatus" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Picking Item" :bordered="true" :items="pickingForDeliveryDetails" :fields="fieldsPickingForDeliveryDetail" :busy="isDataLoading" :sort-by.sync="sortByPickingForDeliveryDetail" :sort-desc.sync="sortDescPickingForDeliveryDetail" small responsive
			@editButtonMethod="editRowDataPickingForDeliveryDetail"
			@deleteButtonMethod="deleteRowDataPickingForDeliveryDetail"
			@showPopupAddMethod="resetDataPickingForDeliveryDetail()"
			@showPopupUploadMethod="showPopupUploadPickingForDeliveryDetail()"
			@downloadMethod="downloadPickingForDeliveryDetail()"
			@addFromClipboardMethod="addFromClipboardPickingForDeliveryDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingForDeliveryDetail()"
			:showActionButton="isEditable"
			:showEditButton="isEditable"
			:showDeleteButton="isEditable"
			:showAddButton="isEditable"
			:showAddFromClipboardButton="isEditable"
			:showReplaceFromClipboardButton="isEditable"
			:showUploadButton="isEditable"
			:showDownloadButton="isEditable"
			:isDownloadBusy="isDownloadPickingForDeliveryDetail"
			>
			<template #top-row v-if="isShowPickingForDeliveryDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Delivery Instruction Detail">
					<v-select append-to-body label="part" :options="deliveryInstructionDetails"  :value="filterPickingForDeliveryDetail.deliveryInstructionDetailId" :reduce="item => item.id" v-model="filterPickingForDeliveryDetail.deliveryInstructionDetailId" @search="getDeliveryInstructionDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Plan Qty">
					<b-form-input id="input-plan-qty-table" v-model="filterPickingForDeliveryDetail.planQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Actual Qty">
					<b-form-input id="input-actual-qty-table" v-model="filterPickingForDeliveryDetail.actualQty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingForDeliveryDetailPageSize * (currentPickingForDeliveryDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(deliveryInstructionDetail)="row">
				{{  row.item.deliveryInstructionDetail!= null && row.item.deliveryInstructionDetail.part!=null ? row.item.deliveryInstructionDetail.part.partNumber:""}}
				<!-- <app-input-combobox-autocomplete :options="deliveryInstructionDetails" optionsLabel="part" optionsKey="id" :id="'input-picking-for-delivery-detail-delivery-instruction-detail-' + row.index" label-cols-lg="12" label="Delivery Instruction Detail" size="sm" :model.sync="row.item.deliveryInstructionDetailId" :state="validateState('deliveryInstructionDetailId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionDetailId, 'deliveryInstructionDetailId')"  @change="saveInputPickingForDeliveryDetail(row.item)" :selected="row.item.deliveryInstructionDetail != null &&  row.item.deliveryInstructionDetail.part != null? row.item.deliveryInstructionDetail.partPartNumber : ''"  @input="getDeliveryInstructionDetails" :loading="isDeliveryInstructionDetailComboLoading"   :isUpdatable="isEditable"  :isEditable="isEditable" :nolabel="true" /> -->
			</template>
			<template v-slot:cell(planQty)="row">
				<app-input-textbox :id="'input-picking-for-delivery-detail-plan-qty-' + row.index" label-cols-lg="12" label="Plan Qty" size="sm" :model.sync="row.item.planQty"   @change="saveInputPickingForDeliveryDetail(row.item)"  :isUpdatable="isEditable"  :isEditable="isEditable" :nolabel="true" />
			</template>
			<template v-slot:cell(actualQty)="row">
				<app-input-textbox :id="'input-picking-for-delivery-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputPickingForDeliveryDetail(row.item)"  :isUpdatable="isEditable"  :isEditable="isEditable" :nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				{{ row.item.remark }}
			</template>

			<template v-slot:form-add-detail>
				<PickingForDeliveryDetailInput 
					:openPopup="isShowPopupPickingForDeliveryDetail"
					:modelId="pickingForDeliveryDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingForDeliveryDetail"/>
			</template>
			<template v-slot:upload-detail>
				<PickingForDeliveryDetailUpload
					:openPopup="isShowPopupUploadPickingForDeliveryDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingForDeliveryDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-picking-for-delivery-detail-plan-qty-' + row.index" label-cols-lg="12" label="Plan Qty" size="sm" :model.sync="row.item.planQty"   @change="saveInputPickingForDeliveryDetail(row.item)" :isUpdatable="isEditable" :isEditable="isEditable"  />
					<app-input-textbox :id="'input-picking-for-delivery-detail-actual-qty-' + row.index" label-cols-lg="12" label="Actual Qty" size="sm" :model.sync="row.item.actualQty"   @change="saveInputPickingForDeliveryDetail(row.item)" :isUpdatable="isEditable" :isEditable="isEditable"  />
				</b-card>
			</template>

			<template #table-paging>
				<b-row>
					<b-col cols="12" class="paging-container">
						<div>
							<b-row>
								<b-col cols="12" class="paging-item">
									<b-pagination class="btn-paging paging-page-size float-right"
										v-model="currentPickingForDeliveryDetailPage"
										:total-rows="(pickingForDeliveryDetailsPaging != null ? pickingForDeliveryDetailsPaging.dataCount : 0)"
										:per-page="(pickingForDeliveryDetailsPaging != null ? pickingForDeliveryDetailsPaging.pageSize : 0)"
										aria-controls="table-input">
										<template #first-text>
											<b-icon-chevron-left />
										</template>
										<template #prev-text>
											Prev
										</template>
										<template #next-text>
											Next
										</template>
										<template #last-text>
											<b-icon-chevron-right />
										</template>
									</b-pagination>
									<!-- <span class="paging-page-size float-right">
										<b-form-select v-if="false" v-model="pickingForDeliveryDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										<b-dropdown :text="pickingForDeliveryDetailPageSize + ' per page'" class="m-md-2 btn-paging-size" size="sm">
											<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pickingForDeliveryDetailPageSize = item.value">
												{{ item.text }}
											</b-dropdown-item>
										</b-dropdown>
									</span> -->
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</template>

		</app-table-input-popup>
		<app-table-input-popup title="Picking Card" :bordered="true" :items="pickingCardDetails" :fields="fieldsPickingCardDetail" :busy="isDataLoading" :sort-by.sync="sortByPickingCardDetail" :sort-desc.sync="sortDescPickingCardDetail" small responsive
			@editButtonMethod="editRowDataPickingCardDetail"
			@deleteButtonMethod="deleteRowDataPickingCardDetail"
			@showPopupAddMethod="resetDataPickingCardDetail()"
			@showPopupUploadMethod="showPopupUploadPickingCardDetail()"
			@downloadMethod="downloadPickingCardDetail()"
			@addFromClipboardMethod="addFromClipboardPickingCardDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardPickingCardDetail()"
			:showActionButton="isEditable"
			:showEditButton="isEditable"
			:showDeleteButton="isEditable"
			:showAddButton="isEditable"
			:showAddFromClipboardButton="isEditable"
			:showReplaceFromClipboardButton="isEditable"
			:showUploadButton="isEditable"
			:showDownloadButton="isEditable"
			:isDownloadBusy="isDownloadPickingCardDetail"
			>
			<template #top-row v-if="isShowPickingCardDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Picking Detail">
					<v-select append-to-body label="deliveryInstructionDetail" :options="pickingForDeliveryDetails"  :value="filterPickingCardDetail.pickingDetailId" :reduce="item => item.id" v-model="filterPickingCardDetail.pickingDetailId" @search="getPickingForDeliveryDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Card">
					<v-select append-to-body label="deliveryCardNumber" :options="deliveryInstructionDeliveryCards"  :value="filterPickingCardDetail.deliveryCardId" :reduce="item => item.id" v-model="filterPickingCardDetail.deliveryCardId" @search="getDeliveryInstructionDeliveryCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterPickingCardDetail.controlCardId" :reduce="item => item.id" v-model="filterPickingCardDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Scan Date">
					<app-input-datetimepicker-range id="fieldset-scan-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Scan Date" size="sm" :modelFrom.sync="filterPickingCardDetail.scanDateFrom" :modelTo.sync="filterPickingCardDetail.scanDateTo" :date-format-options="{ year: 'numeric', month: '4-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Scan By">
					<v-select append-to-body label="firstName" :options="userInfos"  :value="filterPickingCardDetail.scanById" :reduce="item => item.id" v-model="filterPickingCardDetail.scanById" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Delivery Qty">
					<b-form-input id="input-delivery-qty-table" v-model="filterPickingCardDetail.deliveryQty" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pickingCardDetailPageSize * (currentPickingCardDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(pickingDetail)="row">
				{{  row.item.pickingDetail!=null && row.item.pickingDetail.deliveryInstructionDetail!=null && row.item.pickingDetail.deliveryInstructionDetail.part!= null ? row.item.pickingDetail.deliveryInstructionDetail.part.partNumber :""}}
				<!-- <app-input-combobox-autocomplete :options="pickingForDeliveryDetails" optionsLabel="deliveryInstructionDetail" optionsKey="id" :id="'input-picking-card-detail-picking-detail-' + row.index" label-cols-lg="12" label="Picking Detail" size="sm" :model.sync="row.item.pickingDetailId"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.pickingDetail != null ? row.item.pickingDetail.id : ''"  @input="getPickingForDeliveryDetails" :loading="isPickingForDeliveryDetailComboLoading"   :isUpdatable="isEditable"  :isEditable="isEditable" :nolabel="true" /> -->
			</template>
			<template v-slot:cell(deliveryCard)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDeliveryCards" optionsLabel="deliveryCardNumber" optionsKey="id" :id="'input-picking-card-detail-delivery-card-' + row.index" label-cols-lg="12" label="Delivery Card" size="sm" :model.sync="row.item.deliveryCardId" :state="validateState('deliveryCardId')" :errorMessage="getErrorMessage(errorMessage.deliveryCardId, 'deliveryCardId')"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.deliveryCard != null ? row.item.deliveryCard.deliveryCardNumber : ''"  @input="getDeliveryInstructionDeliveryCards" :loading="isDeliveryInstructionDeliveryCardComboLoading"   :isUpdatable="isEditable"  :isEditable="isEditable"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-card-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="isEditable"  :isEditable="isEditable"   :nolabel="true" />
			</template>
			<template v-slot:cell(scanDate)="row">
				{{ row.item.scanDate|moment('DD MMM YYYY') }}
				<!-- <app-input-datetimepicker :id="'input-picking-card-detail-scan-date-' + row.index" label-cols-lg="12" label="Scan Date" size="sm" :model.sync="row.item.scanDate"   @change="saveInputPickingCardDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="isEditable"  :isEditable="isEditable"   :nolabel="true" /> -->
			</template>
			<template v-slot:cell(scanBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-picking-card-detail-scan-by-' + row.index" label-cols-lg="12" label="Scan By" size="sm" :model.sync="row.item.scanById"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.scanBy != null ? row.item.scanBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"   :isUpdatable="isEditable"  :isEditable="isEditable"   :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryQty)="row">
				<app-input-textbox :id="'input-picking-card-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputPickingCardDetail(row.item)"  :isUpdatable="isEditable"  :isEditable="isEditable"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<PickingCardDetailInput 
					:openPopup="isShowPopupPickingCardDetail"
					:modelId="pickingCardDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPickingCardDetail"/>
			</template>
			<template v-slot:upload-detail>
				<PickingCardDetailUpload
					:openPopup="isShowPopupUploadPickingCardDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPickingCardDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="deliveryInstructionDeliveryCards" optionsLabel="deliveryCardNumber" optionsKey="id" :id="'input-picking-card-detail-delivery-card-' + row.index" label-cols-lg="12" label="Delivery Card" size="sm" :model.sync="row.item.deliveryCardId" :state="validateState('deliveryCardId')" :errorMessage="getErrorMessage(errorMessage.deliveryCardId, 'deliveryCardId')"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.deliveryCard != null ? row.item.deliveryCard.deliveryCardNumber : ''"  @input="getDeliveryInstructionDeliveryCards" :loading="isDeliveryInstructionDeliveryCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-picking-card-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-datetimepicker :id="'input-picking-card-detail-scan-date-' + row.index" label-cols-lg="12" label="Scan Date" size="sm" :model.sync="row.item.scanDate"   @change="saveInputPickingCardDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-picking-card-detail-scan-by-' + row.index" label-cols-lg="12" label="Scan By" size="sm" :model.sync="row.item.scanById"  @change="saveInputPickingCardDetail(row.item)" :selected="row.item.scanBy != null ? row.item.scanBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-picking-card-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputPickingCardDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

			<template #table-paging>
				<b-row>
					<b-col cols="12" class="paging-container">
						<div>
							<b-row>
								<b-col cols="12" class="paging-item">
									<b-pagination class="btn-paging paging-page-size float-right"
										v-model="currentPickingCardDetailPage"
										:total-rows="(pickingCardDetailsPaging != null ? pickingCardDetailsPaging.dataCount : 0)"
										:per-page="(pickingCardDetailsPaging != null ? pickingCardDetailsPaging.pageSize : 0)"
										aria-controls="table-input">
										<template #first-text>
											<b-icon-chevron-left />
										</template>
										<template #prev-text>
											Prev
										</template>
										<template #next-text>
											Next
										</template>
										<template #last-text>
											<b-icon-chevron-right />
										</template>
									</b-pagination>
									<!-- <span class="paging-page-size float-right">
										<b-form-select v-if="false" v-model="pickingCardDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										<b-dropdown :text="pickingCardDetailPageSize + ' per page'" class="m-md-2 btn-paging-size" size="sm">
											<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pickingCardDetailPageSize = item.value">
												{{ item.text }}
											</b-dropdown-item>
										</b-dropdown>
									</span> -->
								</b-col>
							</b-row>
						</div>
					</b-col>
				</b-row>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PickingForDelivery from '@/models/PickingForDelivery/PickingForDelivery';
import PickingForDeliveryList from '@/models/PickingForDelivery/PickingForDeliveryList';
import PickingForDeliveryFilter from '@/filters/PickingForDelivery/PickingForDeliveryFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import PickingStatus from '@/models/PickingStatus/PickingStatus';
import PickingStatusFilter from '@/filters/PickingStatus/PickingStatusFilter';
import PickingForDeliveryDetail from '@/models/PickingForDelivery/PickingForDeliveryDetail';
import PickingForDeliveryDetailFilter from '@/filters/PickingForDelivery/PickingForDeliveryDetailFilter';
import PickingCardDetail from '@/models/PickingForDelivery/PickingCardDetail';
import PickingCardDetailFilter from '@/filters/PickingForDelivery/PickingCardDetailFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PickingForDeliveryDetailInput from '@/views/PickingForDelivery/PickingForDeliveryDetailInput';
import PickingForDeliveryDetailUpload from '@/views/PickingForDelivery/PickingForDeliveryDetailUpload';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PickingCardDetailInput from '@/views/PickingForDelivery/PickingCardDetailInput';
import PickingCardDetailUpload from '@/views/PickingForDelivery/PickingCardDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		PickingForDeliveryDetailInput,PickingForDeliveryDetailUpload,
		PickingCardDetailInput,PickingCardDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			deliveryInstructionId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				deliveryInstructionId: { required : "Delivery Instruction is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsPickingForDeliveryDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail first-child", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail', sortable: false}}, 
				{"planQty": { "class" : "th-plan-qty d-stack-none", "label" : "Plan Qty", key: 'planQty', sortable: false}}, 
				{"actualQty": { "class" : "th-actual-qty d-stack-none ", "label" : "Actual Qty", key: 'actualQty', sortable: false}}, 
				{"remark": { "class" : "th-remark d-stack-none", "label" : "Remarks", key: 'remark', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsPickingCardDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"pickingDetail": { "class" : "th-picking-detail first-child", "label" : "Picking Detail", key: 'pickingDetail', sortable: false}}, 
				{"deliveryCard": { "class" : "th-delivery-card", "label" : "Delivery Card", key: 'deliveryCard', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card last-child", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"scanDate": { "class" : "th-scan-date d-stack-none", "label" : "Scan Date", key: 'scanDate', sortable: false}}, 
				{"scanBy": { "class" : "th-scan-by d-stack-none", "label" : "Scan By", key: 'scanBy', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isEditable:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPickingForDeliveryDetail : {},
			isShowPopupPickingForDeliveryDetail : false,
			isShowPopupUploadPickingForDeliveryDetail : false,
			modelPickingCardDetail : {},
			isShowPopupPickingCardDetail : false,
			isShowPopupUploadPickingCardDetail : false,
			filterPickingForDelivery : null,
			currentPickingForDeliveryPage : 1,
			pickingForDeliveryPageSize: 10,
			sortByPickingForDelivery: '',
			sortDescPickingForDelivery: '',
			filterPickingForDeliveryDetail : null,
			currentPickingForDeliveryDetailPage : 1,
			pickingForDeliveryDetailPageSize: 10,
			sortByPickingForDeliveryDetail: '',
			sortDescPickingForDeliveryDetail: '',
			sortingByPickingForDeliveryDetail: [],
			pickingForDeliveryDetails : [],
			pickingForDeliveryDetailId : '',
			totalPickingForDeliveryDetailRow : 0,
			isShowPickingForDeliveryDetailFilter: false,
			isDownloadPickingForDeliveryDetail: false,
			filterPickingCardDetail : null,
			currentPickingCardDetailPage : 1,
			pickingCardDetailPageSize: 10,
			sortByPickingCardDetail: '',
			sortDescPickingCardDetail: '',
			sortingByPickingCardDetail: [],
			pickingCardDetails : [],
			pickingCardDetailId : '',
			totalPickingCardDetailRow : 0,
			isShowPickingCardDetailFilter: false,
			isDownloadPickingCardDetail: false,
			deliveryInstructionDetails: [],
			deliveryInstructionDeliveryCards: [],
			controlCards: [],
			userInfos: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			pickingStatuss: [],
			isPickingStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isUserInfoComboLoading: false,
			isPickingForDeliveryComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPickingForDeliveryDetailComboLoading: false,
			isDeliveryInstructionDeliveryCardComboLoading: false,
			isControlCardComboLoading: false,
			pickingForDeliveryDetailsPaging: [],
			pickingCardDetailsPaging: [],
		}
	},
	methods : {
		getPickingForDelivery : async function(id) {
			this.isBusy = true;
			//await PickingForDelivery.getData(this, id).then(result => {
			await this.$http.get(`pickingfordelivery/${id}?includeChilds=false`).then(async result => {
				this.model = result.data;
				console.log("model in getPickingDelivery", this.model);
				this.mainRecordId = String(result.data.id);
				let promises = Array();
				//this.pickingCardDetails = this.model.pickingCardDetail;
				//this.pickingForDeliveryDetails = this.model.pickingForDeliveryDetail;
				await this.getPickingForDeliveryDetails();
				await this.getPickingCardDetails();


				Promise.all(promises).then(() => {
					this.isBusy = false;
				});
			}).catch(() => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPickingForDelivery = true;
			this.filterPickingForDelivery.id = this.modelId;
			PickingForDelivery.downloadDataDetail(this, this.filterPickingForDelivery).then(result => {
				this.isDownloadPickingForDelivery = false;
			}).catch(() => { this.isDownloadPickingForDelivery = false; })
		},
		getPickingForDeliveryDetails : async function(isAddRow) {
			//return;
			let filter = {};
			Object.assign(filter, this.filterPickingForDeliveryDetail);
			if (this.modelId == null) return;
			filter.pickingForDeliveryId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingForDeliveryDetail != null) {
				this.sortingByPickingForDeliveryDetail[this.sortByPickingForDeliveryDetail] = this.sortDescPickingForDeliveryDetail;
			}
			let currentPage = (this.currentPickingForDeliveryDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingForDeliveryDetailRow + 1;
				let page = Math.ceil(totalData/this.pickingForDeliveryDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = null;
			//this.pickingForDeliveryDetailPageSize = 0;
			// disable paging end
			await PickingForDeliveryDetail.getList(this, filter, this.sortingByPickingForDeliveryDetail, currentPage , this.pickingForDeliveryDetailPageSize).then(result => {
				this.currentPickingForDeliveryDetailPage = currentPage + 1;
				this.pickingForDeliveryDetails = result.data;
				this.totalPickingForDeliveryDetailRow = result.dataCount;
				this.pickingForDeliveryDetailsPaging = result;
			}).catch(() => {});
		},
		getPickingCardDetails : async function(isAddRow) {
			//return
			let filter = {};
			Object.assign(filter, this.filterPickingCardDetail);
			if (this.modelId == null) return;
			filter.pickingForDeliveryId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPickingCardDetail != null) {
				this.sortingByPickingCardDetail[this.sortByPickingCardDetail] = this.sortDescPickingCardDetail;
			}
			let currentPage = (this.currentPickingCardDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPickingCardDetailRow + 1;
				let page = Math.ceil(totalData/this.pickingCardDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			//currentPage = null;
			//this.pickingCardDetailPageSize = 0;
			// disable paging end
			await PickingCardDetail.getList(this, filter, this.sortingByPickingCardDetail, currentPage , this.pickingCardDetailPageSize).then(result => {
				this.currentPickingCardDetailPage = currentPage + 1;
				this.pickingCardDetails = result.data;
				this.totalPickingCardDetailRow = result.dataCount;
				this.pickingCardDetailsPaging = result;
			}).catch(() => {});
		},
		getPickingForDeliverys : async function(input) {
			let filter = new PickingForDeliveryFilter();
			if (input != undefined) {
				filter.PickingNumber = input;
			}
			this.isPickingForDeliveryComboLoading = true;
			PickingForDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingForDeliverys = result.data
				}
				this.isPickingForDeliveryComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			if (input != undefined) {
				filter.deliveryCardNumber = input;
			}
			this.isDeliveryInstructionDeliveryCardComboLoading = true;
			DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
				}
				this.isDeliveryInstructionDeliveryCardComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstruction(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedPickingBy(item) {
			if(item == undefined || item == null) {
				this.model.pickingByUserName = null;
				this.model.pickingBy = null;
			} else {
				this.model.pickingByUserName = item.userName;
				this.model.pickingBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPickingStatuss : async function(input) {
			let filter = new PickingStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PickingStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.pickingStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPickingStatus(item) {
			if(item == undefined || item == null) {
				this.model.pickingStatusId = null;
				this.model.pickingStatus = null;
			} else {
				this.model.pickingStatusId = item.id;
				this.model.pickingStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.pickingForDeliveryInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PickingForDelivery.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingfordeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PickingForDelivery.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'pickingfordeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			return;
			// let id = this.modelId;
			// let model = this.model;
			// let promises = Array();

			// Promise.all(promises).then((results) => {
			// 	if (id != '' && id != null && id != undefined) {
			// 		PickingForDelivery.updateDataDetail(this, model, id)
			// 		.catch((error) => {
			// 			this.getPickingForDelivery(id);
			// 		});
			// 	}
			// });
		},
		onHidden() {
			this.getPickingForDeliverys();
		},
		addRowDataPickingForDeliveryDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingForDeliveryId =  this.modelId;
					PickingForDeliveryDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingForDeliveryDetails(true);
						this.isShowPopupPickingForDeliveryDetail = false;
					})
				} else {
					model.pickingForDeliveryId =  this.modelId;
					PickingForDeliveryDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingForDeliveryDetails(true);
						this.isShowPopupPickingForDeliveryDetail = false;
					})
				}
			}
		},
		async editRowDataPickingForDeliveryDetail(id) {
			this.pickingForDeliveryDetailId = id;
			this.isShowPopupPickingForDeliveryDetail = true; 
		},
		async deleteRowDataPickingForDeliveryDetail(id) {
			PickingForDeliveryDetail.deleteData(this, id).then(result => { this.getPickingForDeliveryDetails(); });
		},
		async resetDataPickingForDeliveryDetail() {
			this.pickingForDeliveryDetailId = "";
			this.isShowPopupPickingForDeliveryDetail = true;
		},
		async addDataPickingForDeliveryDetail() {
			PickingForDeliveryDetail.createData(this, { pickingForDeliveryId: this.modelId })
			.then(result => {
				this.getPickingForDeliveryDetails(true);
			})
		},
		async addFromClipboardPickingForDeliveryDetail() {
			let deliveryInstructionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryInstructionDetails.push({ deliveryInstructionDetail: item, pickingForDeliveryId: this.modelId });
				});
				PickingForDeliveryDetail.addFromClipboard(this, deliveryInstructionDetails).then(result => { this.getPickingForDeliveryDetails() });
			});
		},
		async replaceFromClipboardPickingForDeliveryDetail() {
			let deliveryInstructionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryInstructionDetails.push({ deliveryInstructionDetail: item, pickingForDeliveryId: this.modelId });
				});
				PickingForDeliveryDetail.replaceFromClipboard(this, deliveryInstructionDetails).then(result => { this.getPickingForDeliveryDetails() });
			});   
		},
		showPopupUploadPickingForDeliveryDetail() {
			if(this.pickingForDeliveryDetails != null && this.pickingForDeliveryDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingForDeliveryDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingForDeliveryDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingForDeliveryDetail = true;
			}
		},
		uploadDataPickingForDeliveryDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingForDeliveryDetail = false; 
		},
		downloadPickingForDeliveryDetail(modalEvent) {
			this.isDownloadPickingForDeliveryDetail = true;
			this.filterPickingForDeliveryDetail.pickingForDeliveryId = this.modelId;
			PickingForDeliveryDetail.downloadDataDetail(this, this.filterPickingForDeliveryDetail).then(result => {
				this.isDownloadPickingForDeliveryDetail = false;
			}).catch(error => { this.isDownloadPickingForDeliveryDetail = false; })
		},
		saveInputPickingForDeliveryDetail(item) {
			return;
			if (this.pickingForDeliverys != null && this.pickingForDeliverys != undefined  && this.pickingForDeliverys.length > 0) {
				item.pickingForDelivery = this.pickingForDeliverys.find(q => q.id == item.pickingForDeliveryId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingForDeliveryDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataPickingCardDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.pickingForDeliveryId =  this.modelId;
					PickingCardDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPickingCardDetails(true);
						this.isShowPopupPickingCardDetail = false;
					})
				} else {
					model.pickingForDeliveryId =  this.modelId;
					PickingCardDetail.createDataDetail(this, model)
					.then(result => {
						this.getPickingCardDetails(true);
						this.isShowPopupPickingCardDetail = false;
					})
				}
			}
		},
		async editRowDataPickingCardDetail(id) {
			this.pickingCardDetailId = id;
			this.isShowPopupPickingCardDetail = true; 
		},
		async deleteRowDataPickingCardDetail(id) {
			PickingCardDetail.deleteData(this, id).then(result => { this.getPickingCardDetails(); });
		},
		async resetDataPickingCardDetail() {
			this.pickingCardDetailId = "";
			this.isShowPopupPickingCardDetail = true;
		},
		async addDataPickingCardDetail() {
			PickingCardDetail.createData(this, { pickingForDeliveryId: this.modelId })
			.then(result => {
				this.getPickingCardDetails(true);
			})
		},
		async addFromClipboardPickingCardDetail() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, pickingForDeliveryId: this.modelId });
				});
				PickingCardDetail.addFromClipboard(this, deliveryCards).then(result => { this.getPickingCardDetails() });
			});
		},
		async replaceFromClipboardPickingCardDetail() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, pickingForDeliveryId: this.modelId });
				});
				PickingCardDetail.replaceFromClipboard(this, deliveryCards).then(result => { this.getPickingCardDetails() });
			});   
		},
		showPopupUploadPickingCardDetail() {
			if(this.pickingCardDetails != null && this.pickingCardDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PickingCardDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPickingCardDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPickingCardDetail = true;
			}
		},
		uploadDataPickingCardDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPickingCardDetail = false; 
		},
		downloadPickingCardDetail(modalEvent) {
			this.isDownloadPickingCardDetail = true;
			this.filterPickingCardDetail.pickingForDeliveryId = this.modelId;
			PickingCardDetail.downloadDataDetail(this, this.filterPickingCardDetail).then(result => {
				this.isDownloadPickingCardDetail = false;
			}).catch(error => { this.isDownloadPickingCardDetail = false; })
		},
		saveInputPickingCardDetail(item) {
			return;
			if (this.pickingForDeliveryDetails != null && this.pickingForDeliveryDetails != undefined  && this.pickingForDeliveryDetails.length > 0) {
				item.pickingDetail = this.pickingForDeliveryDetails.find(q => q.id == item.pickingDetailId);
			}
			if (this.deliveryInstructionDeliveryCards != null && this.deliveryInstructionDeliveryCards != undefined  && this.deliveryInstructionDeliveryCards.length > 0) {
				item.deliveryCard = this.deliveryInstructionDeliveryCards.find(q => q.id == item.deliveryCardId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.scanBy = this.userInfos.find(q => q.id == item.scanByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PickingCardDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPickingForDeliveryDetail = false; 
			this.isShowPopupPickingForDeliveryDetail = false; 
			if (modalType == 'PickingForDeliveryDetail') {
				this.getPickingForDeliveryDetails();
			}
			this.isShowPopupUploadPickingCardDetail = false; 
			this.isShowPopupPickingCardDetail = false; 
			if (modalType == 'PickingCardDetail') {
				this.getPickingCardDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowPickingForDeliveryDetailFilter = true;
				//this.isShowPickingCardDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPickingForDelivery = new PickingForDeliveryFilter();
		this.filterPickingForDeliveryDetail = new PickingForDeliveryDetailFilter();
		this.filterPickingCardDetail = new PickingCardDetailFilter();
		//this.getPickingForDeliverys();
		//this.getDeliveryInstructionDetails();
		//this.getPickingForDeliveryDetails();
		//this.getDeliveryInstructionDeliveryCards();
		//this.getControlCards();
		//this.getUserInfos();
		//this.getDeliveryInstructions();
		//this.getPickingStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPickingForDelivery(id);
			} else {
				this.modelId = id;
				this.getPickingForDelivery(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByPickingForDeliveryDetail : {
			handler: function() {
				this.getPickingForDeliveryDetails();
			}
		},
		sortDescPickingForDeliveryDetail: {
			handler: function() {
				this.getPickingForDeliveryDetails();
			}
		},
		currentPickingForDeliveryDetailPage: {
			handler: function() {
				this.getPickingForDeliveryDetails();
			}
		},
		pickingForDeliveryDetailPageSize : {
			handler: function() {
				this.getPickingForDeliveryDetails();
			}
		},
		filterPickingForDeliveryDetail: {
			handler: function() {
				this.getPickingForDeliveryDetails();
			},
			deep: true,
		},
		sortByPickingCardDetail : {
			handler: function() {
				this.getPickingCardDetails();
			}
		},
		sortDescPickingCardDetail: {
			handler: function() {
				this.getPickingCardDetails();
			}
		},
		currentPickingCardDetailPage: {
			handler: function() {
				this.getPickingCardDetails();
			}
		},
		pickingCardDetailPageSize : {
			handler: function() {
				this.getPickingCardDetails();
			}
		},
		filterPickingCardDetail: {
			handler: function() {
				this.getPickingCardDetails();
			},
			deep: true,
		},
	},
}
</script>
